import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/settings/')({
  beforeLoad: ({ params, context }) => {
    const { permissions } = context;
    const org = params.org;
    if (permissions.edit_integrations) {
      throw redirect({
        to: '/org/$org/settings/work-integrations',
        params: { org },
        replace: true,
      });
    }
    if (permissions.edit_capacity) {
      throw redirect({ to: '/org/$org/settings/teams', params: { org }, replace: true });
    }
    throw redirect({ to: '/org/$org/settings/notifications', params: { org }, replace: true });
  },
});
